export type UserType = "SystemAdmin" | "TrustedClient" | "OrganizationUser";

export const userTypeOptions: UserType[] = ["SystemAdmin", "TrustedClient", "OrganizationUser"];

export type ApiResourceGrantType = "basic_auth";

export const apiResourceGrantTypeOptions: ApiResourceGrantType[] = ["basic_auth"];

export type TessituraInterfaceType = "Transactions" | "FinancialEdge";

export const tessituraInterfaceTypeOptions: TessituraInterfaceType[] = [
    "Transactions",
    "FinancialEdge",
];

export type MappingDimensionType = "FixedListValuesType" | "CustomListValuesType";

export const mappingDimensionTypeOptions: MappingDimensionType[] = [
    "FixedListValuesType",
    "CustomListValuesType",
];

export type JournalEntryTypeEnum = "Debit" | "Credit";
export const journalEntryTypeOptions: JournalEntryTypeEnum[] = ["Debit", "Credit"];

export type JournalEntryTypeOption = 1 | 2 | 3;

export const journalEntryTypeOptionItems = [
  { value: 1, text: "Debit" },
  { value: 2, text: "Credit" },
  { value: 3, text: "Both" }
];
